<template>
    <!-- Meta Tags -->
    <Head title="Declaración de accesibilidad" />

    <section
        class="bg-legal_mobile lg:bg-legal bg-cover bg-fixed bg-center w-full min-h-screenheaderfooter flex justify-center items-center"
        id="main-content"
    >
        <div class="container py-8">
            <div class="w-full lg:w-1/2">
                <h1 class="mb-4 md:mb-8 text-center lg:text-left uppercase">Declaración de accesibilidad</h1>
                <div class="flex flex-col gap-4 justify-center items-start !text-xs sm:!text-base">
                    <p>La accesibilidad web es un derecho humano en la era digital.</p>
                    <p>
                        Marketing Incluyente es nuestra nueva visión global para transformar en la
                        forma en la que operamos para impactar de manera positiva al medio ambiente y a las comunidades
                        en las que servimos.
                    </p>
                    <p>
                        Y esto abarca también ofrecer servicios y productos accesibles para todas las personas. Es por
                        eso que hemos arrancado una jornada de accesibilidad digital en nuestras plataformas. ¡La
                        accesibilidad web es un derecho humano en la era digital!
                    </p>
                    <p>
                        La accesibilidad se cumple bajo el criterio del estándar internacional “Web Content
                        Accessibility Guidelines 2.1” creado por el grupo de trabajo “Web Accessibility Initiative” del
                        “World Wide Web Consortium” en un nivel de conformidad “A” y ha sido evaluada satisfactoriamente
                        por Todo Accesible A.C.
                    </p>
                    <p>Algunas características de accesibilidad son</p>
                    <ul class="pl-6">
                        <li class="list-disc">Navegación con mouse y con teclado.</li>
                        <li class="list-disc">Enlace para saltar al contenido principal al navegar con teclado.</li>
                        <li class="list-disc">Estructura adecuada de encabezados.</li>
                        <li class="list-disc">Descripción alternativa de imágenes.</li>
                        <li class="list-disc">Textos descriptivos de enlaces.</li>
                        <li class="list-disc">
                            Aumento y disminución del tamaño de letra sin perder contenido o estructura.
                        </li>
                        <li class="list-disc">Descripción textual de videos.</li>
                        <li class="list-disc">Formulario de contacto accesible con lectores de pantalla</li>
                    </ul>
                    <br />

                    <p>
                        La accesibilidad web ofrece igualdad de oportunidades y mejora la calidad de vida de todos,
                        incluyendo a las personas con discapacidad.
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Accessibility",
    props: ["errors"],
};
</script>
<style></style>
